import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography, Box, Tabs, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import { GameType } from "../Types";
export const HeaderComponent = ({ newPracticeGameListener, dailyGameListener, gameType }) => {
    const [value, setValue] = useState(1);
    useEffect(() => {
        if (gameType === GameType.practice) {
            setValue(1);
        }
        else if (gameType === GameType.daily) {
            setValue(0);
        }
    });
    const handleChange = (event, newValue) => {
        switch (newValue) {
            case 0:
                dailyGameListener();
                break;
            case 1:
                newPracticeGameListener();
                break;
        }
    };
    return (_jsx(Stack, { sx: {
            width: "100%",
            marginLeft: "100px",
            marginRight: "100px",
            background: "#eeeeee",
            direction: "row",
            alignItems: "center",
        }, children: _jsxs(Stack, { direction: "row", sx: {
                width: "300px",
                alignItems: "center",
                spacing: "30px",
                justifyContent: "space-between",
            }, children: [_jsx(Box, { sx: {
                        marginLeft: "10px",
                    }, children: _jsx(Typography, { fontWeight: "bold", children: "ENSPADLE" }) }), _jsx(Stack, { direction: "row", children: _jsxs(Tabs, { value: value, onChange: handleChange, children: [_jsx(Tab, { disabled: true, label: "Daily" }), _jsx(Tab, { label: "Practice" })] }) })] }) }));
};
